import { useQuery } from "react-query";
import { PensionContext, PensionParameters } from "../../contexts/pension-robot/PensionContext";
import { defaultHeaders } from "../robotapi";
import { useContext } from "react";
import { RobotEnvironmentContext } from "../../contexts/general/RobotEnvironmentContext";
import { buildEndpoint } from "../endpoints";

export interface PensionDialogueDataRequest {
    id: string,
    answers: {
        generalSituation: {
            age: number
        }
    }
};

export const pensionDialogueDataToRequest = (params: PensionParameters, userToken: string) : PensionDialogueDataRequest => {
    return {
        id: userToken,
        answers: mapDialogueDataToRequestBody(params)
    };
};

const mapDialogueDataToRequestBody = (params: PensionParameters) => {
    return {
        generalSituation: {
            age: params.personalInfo.self?.age ?? 0
        }
    };
};

const getUrl = () => {
    return buildEndpoint(['pensiondata', 'client']);
}

// Assumption, userId doesn't change in session
export const usePostDialogueData = () => {
    const { parameters } = useContext(PensionContext)
    const { userToken } = useContext(RobotEnvironmentContext)

    const query = useQuery(
        ['pensiondata', parameters],
        async () => {
            // If not tokenID, no requests should be made
            if (!userToken)
                return undefined;

            const request: RequestInit = {
                method: "POST",
                headers: defaultHeaders,
                body: JSON.stringify(pensionDialogueDataToRequest(parameters, userToken)),
            };
            const response = await fetch(getUrl(), request);

            if (!response.ok) {
                throw new Error(`Network error with response ${response}`);
            }

            return response;
        },
        {
            enabled: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );

    return query;
}

// export const postDialogueDataApiCall = (userToken: string, params: PensionParameters) =>
//     apifetch<PensionDialogueDataResponse, PensionDialogueDataRequest>
//         (getPensionDialogueDataUrl(userToken), 'POST')
//         (pensionDialogueDataToRequest(params, userToken));

// Assumption, userId doesn't change in session
// export const usePostDialogueData = () => {
//     const { parameters } = useContext(PensionContext)
//     const { userToken } = useContext(RobotEnvironmentContext)

//     const query = useQuery<PensionDialogueDataResponse | undefined, PensionDialogueDataRequest>(
//         ['pensiondata', parameters],
//         async () => {
//             if (!userToken)
//                 return undefined
//             return postDialogueDataApiCall(userToken, parameters);
//         },
//     {
//         enabled: false,
//         refetchOnWindowFocus: false,
//         refetchOnReconnect: false
//     });

//     return query;
// }
